import React from 'react'

import NotificationForm from './components/NotificationForm'
import NotificationList from './components/NotificationList'

const Notification: React.FC = () => {
  return (
    <div className="row">
      <NotificationForm />
      <NotificationList />
    </div>
  )
}

export default Notification
